<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between" xs12 mt-3>
          <h1 class="headline">{{ $t('auto.internalMaintenance') }}</h1>
        </v-flex>
      </v-layout>

      <internal-maintenance-table investor />
    </v-flex>
  </v-layout>
</template>

<script>
import InternalMaintenanceTable from '../../components/auto/InternalMaintenanceTable.vue';

export default {
  components: { InternalMaintenanceTable },
  data: () => ({
    userId: JSON.parse(localStorage.getItem('me')).id,
  }),
};
</script>

<style></style>
